var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 144,
    viewBox: "0 0 304 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.401 143.999H33.0789C32.5353 143.999 31.9984 143.879 31.5066 143.647C31.0149 143.416 30.5805 143.079 30.2347 142.66C29.8888 142.241 29.6399 141.752 29.506 141.226C29.372 140.7 29.3562 140.151 29.4597 139.618L54.3626 11.4828C54.5256 10.6442 54.9759 9.88822 55.6363 9.34469C56.2966 8.80116 57.1259 8.50391 57.9818 8.50391H148.304C148.848 8.50391 149.385 8.62391 149.876 8.85532C150.368 9.08674 150.802 9.42383 151.148 9.84246C151.494 10.2611 151.743 10.7509 151.877 11.2768C152.011 11.8026 152.027 12.3516 151.923 12.8843L127.02 141.02C126.857 141.858 126.407 142.614 125.747 143.158C125.086 143.701 124.257 143.999 123.401 143.999Z",
    fill: "#40404D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 11.5312L114.841 120.533H60.2361L136.848 11.5312Z",
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.215 76.1215C128.21 51.289 133.305 27.7983 137.25 11.5312H65.9804C60.4294 34.4502 51.0775 56.2813 38.3118 76.1215C27.6719 92.6309 14.7771 107.579 0 120.533H73.9033C88.6804 107.579 101.575 92.6309 112.215 76.1215Z",
    fill: "#2B2B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.272 16.5169H87.4134C86.6985 16.5169 86.161 16.0809 86.2971 15.6114L89.2629 4.89522C89.3635 4.69095 89.5245 4.52239 89.7241 4.41228C89.9237 4.30218 90.1523 4.25582 90.3792 4.27946H118.238C118.953 4.27946 119.49 4.71547 119.354 5.1849L116.388 15.9011C116.288 16.1054 116.127 16.2739 115.927 16.384C115.728 16.4942 115.499 16.5405 115.272 16.5169Z",
    fill: "#C8C8C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1898 28.3078L111.058 27.5508",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.884 27.6383L124.797 27.4648",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1634 37.7453L108.031 36.9883",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.857 37.0758L121.771 36.9023",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3879 47.1549L103.255 46.3984",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.081 46.4826L116.995 46.3086",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9721 56.6476L98.8403 55.8906",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.666 55.9781L112.58 55.8047",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4174 66.0344L93.2849 65.2773",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1109 65.3649L107.025 65.1914",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5475 75.507L86.4151 74.75",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.241 74.8342L100.155 74.6602",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6776 85.0656L79.5452 84.3086",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3711 84.3961L93.2848 84.2227",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3305 94.7101L71.1987 93.9531",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0248 94.0412L84.938 93.8672",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4607 104.445L64.3288 103.688",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1549 103.771L78.0687 103.598",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3736 114.261L53.2417 113.504",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0678 113.591L66.981 113.418",
    stroke: "#C8C8C8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.19 32.1602H222.48V144H136.433C135.838 144 135.268 143.764 134.847 143.345C134.427 142.925 134.19 142.356 134.19 141.762V32.1602Z",
    fill: "#565666"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.48 32.1602H268.679V141.762C268.679 142.356 268.443 142.925 268.023 143.345C267.602 143.764 267.032 144 266.437 144H222.48V32.1602Z",
    fill: "#2B2B33"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151.283 55.75H135.324C134.705 55.75 134.203 56.251 134.203 56.869V65.7328C134.203 66.3508 134.705 66.8518 135.324 66.8518H151.283C151.902 66.8518 152.404 66.3508 152.404 65.7328V56.869C152.404 56.251 151.902 55.75 151.283 55.75Z",
    fill: "#2B2B33"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M244.3 118.523H228.341C227.722 118.523 227.22 119.024 227.22 119.642V128.506C227.22 129.124 227.722 129.625 228.341 129.625H244.3C244.919 129.625 245.421 129.124 245.421 128.506V119.642C245.421 119.024 244.919 118.523 244.3 118.523Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M267.558 74.6211H251.599C250.98 74.6211 250.478 75.1221 250.478 75.7401V84.6039C250.478 85.2219 250.98 85.7229 251.599 85.7229H267.558C268.177 85.7229 268.679 85.2219 268.679 84.6039V75.7401C268.679 75.1221 268.177 74.6211 267.558 74.6211Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.099 61.3029H290.107C290.515 61.3029 290.913 61.185 291.255 60.9634C291.596 60.7419 291.866 60.4262 292.032 60.0547C292.198 59.6831 292.252 59.2716 292.188 58.87C292.124 58.4684 291.944 58.094 291.672 57.792L268.511 32.1602H221.912L247.533 60.6059C247.73 60.8253 247.972 61.0007 248.242 61.1208C248.512 61.2408 248.804 61.3029 249.099 61.3029Z",
    fill: "#565666"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.48 32.1602H134.19L114.008 57.9045C113.765 58.2149 113.614 58.5873 113.572 58.9793C113.531 59.3712 113.6 59.767 113.773 60.1213C113.946 60.4756 114.215 60.7743 114.55 60.9832C114.885 61.1921 115.272 61.3029 115.667 61.3029H198.607C198.927 61.3029 199.242 61.2302 199.53 61.0904C199.817 60.9506 200.069 60.7473 200.266 60.496L222.48 32.1602Z",
    fill: "#A8A8A8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.832 136.63H146.917C146.414 136.63 145.931 136.83 145.574 137.186C145.218 137.542 145.018 138.024 145.017 138.527V142.226C145.017 142.458 145.062 142.688 145.15 142.903C145.239 143.119 145.369 143.314 145.534 143.479C145.698 143.644 145.893 143.774 146.108 143.864C146.324 143.953 146.554 143.999 146.787 143.999H184.962C185.195 143.999 185.426 143.953 185.641 143.864C185.856 143.774 186.051 143.644 186.215 143.479C186.38 143.314 186.51 143.119 186.599 142.903C186.687 142.688 186.732 142.458 186.732 142.226V138.527C186.731 138.024 186.531 137.542 186.175 137.186C185.819 136.83 185.335 136.63 184.832 136.63ZM184.832 74.6172H146.917C146.414 74.6175 145.931 74.8174 145.574 75.173C145.218 75.5286 145.018 76.0108 145.017 76.5136V80.2126C145.017 80.4451 145.062 80.6755 145.15 80.8905C145.239 81.1056 145.369 81.3011 145.534 81.4659C145.698 81.6306 145.893 81.7614 146.108 81.8507C146.324 81.9399 146.554 81.986 146.787 81.9862H184.962C185.195 81.986 185.426 81.9399 185.641 81.8507C185.856 81.7614 186.051 81.6306 186.215 81.4658C186.38 81.3011 186.51 81.1056 186.599 80.8905C186.687 80.6755 186.732 80.4451 186.732 80.2126V76.5136C186.731 76.0108 186.531 75.5286 186.175 75.173C185.819 74.8174 185.335 74.6175 184.832 74.6172Z",
    fill: "#898999"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M178.904 115.571C176.592 113.587 173.838 112.183 170.871 111.478C170.455 111.385 170.082 111.156 169.814 110.826C169.545 110.496 169.395 110.085 169.389 109.659V109.378C169.395 108.952 169.545 108.542 169.814 108.212C170.083 107.882 170.455 107.652 170.871 107.559C173.837 106.858 176.591 105.459 178.904 103.477C186.1 97.2329 186.106 87.0974 178.904 80.8516H152.848C145.646 87.0974 145.646 97.2271 152.848 103.472C155.16 105.451 157.912 106.852 160.875 107.559C161.292 107.651 161.665 107.881 161.934 108.211C162.203 108.541 162.352 108.952 162.357 109.378V109.66C162.352 110.085 162.203 110.496 161.934 110.827C161.665 111.157 161.292 111.386 160.875 111.478C157.911 112.177 155.157 113.577 152.848 115.56C145.646 121.81 145.646 131.946 152.842 138.19H178.904C186.106 131.946 186.1 121.816 178.904 115.571Z",
    fill: "#C4C4CC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.256 115.571C180.944 113.587 178.19 112.183 175.223 111.478C174.807 111.385 174.435 111.156 174.166 110.826C173.897 110.496 173.747 110.085 173.741 109.659V109.378C173.748 108.952 173.897 108.542 174.166 108.212C174.435 107.882 174.807 107.652 175.223 107.559C178.189 106.858 180.943 105.459 183.256 103.477C190.452 97.2329 190.458 87.0974 183.256 80.8516H157.2C149.998 87.0974 149.998 97.2271 157.2 103.472C159.513 105.451 162.264 106.852 165.227 107.559C165.644 107.651 166.017 107.881 166.286 108.211C166.555 108.541 166.704 108.952 166.709 109.378V109.66C166.704 110.085 166.555 110.496 166.286 110.827C166.017 111.157 165.644 111.386 165.227 111.478C162.263 112.177 159.51 113.577 157.2 115.56C149.998 121.81 149.998 131.946 157.194 138.19H183.256C190.458 131.946 190.452 121.816 183.256 115.571Z",
    fill: "#DBE8EC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.208 114.605V109.326C172.215 108.536 172.488 107.77 172.984 107.154C173.48 106.537 174.169 106.105 174.941 105.926C177.71 105.27 180.281 103.963 182.442 102.115C183.966 100.857 185.197 99.2835 186.051 97.5034C186.905 95.7233 187.361 93.7792 187.387 91.8058C187.384 91.2445 187.344 90.6839 187.268 90.1276C184.411 88.74 180.264 87.4521 167.643 89.4454C159.281 90.7607 155.48 89.123 153.772 87.6328C153.305 88.9728 153.066 90.3813 153.064 91.8C153.091 93.774 153.548 95.7184 154.403 97.4987C155.258 99.2789 156.49 100.853 158.014 102.11C160.176 103.958 162.747 105.266 165.516 105.926C166.286 106.105 166.973 106.537 167.467 107.153C167.962 107.768 168.235 108.532 168.243 109.32V114.605C168.243 117.182 167.42 119.692 165.895 121.772C164.369 123.851 162.219 125.391 159.758 126.169L153.126 128.263C153.461 131.644 155.047 134.779 157.574 137.054H182.877C185.404 134.779 186.99 131.644 187.324 128.263L180.694 126.169C178.232 125.391 176.083 123.851 174.557 121.772C173.031 119.693 172.208 117.182 172.208 114.605Z",
    fill: "#C4C4CC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.185 136.63H151.271C151.021 136.63 150.774 136.679 150.543 136.774C150.313 136.869 150.103 137.009 149.926 137.185C149.75 137.362 149.61 137.571 149.515 137.801C149.419 138.032 149.371 138.279 149.371 138.528V142.225C149.37 142.458 149.416 142.688 149.504 142.903C149.593 143.119 149.723 143.314 149.887 143.479C150.052 143.644 150.247 143.774 150.462 143.864C150.677 143.953 150.908 143.999 151.141 143.999H189.316C189.549 143.999 189.779 143.953 189.994 143.864C190.209 143.774 190.405 143.644 190.569 143.479C190.734 143.314 190.864 143.119 190.952 142.903C191.041 142.688 191.086 142.458 191.085 142.225V138.528C191.086 138.279 191.037 138.032 190.942 137.801C190.846 137.571 190.706 137.362 190.53 137.185C190.353 137.009 190.144 136.869 189.913 136.774C189.682 136.679 189.435 136.63 189.185 136.63ZM189.185 74.6172H151.271C150.767 74.6175 150.284 74.8174 149.928 75.173C149.572 75.5286 149.371 76.0108 149.371 76.5136V80.2126C149.37 80.4451 149.416 80.6755 149.504 80.8905C149.593 81.1056 149.723 81.3011 149.887 81.4659C150.052 81.6306 150.247 81.7614 150.462 81.8507C150.677 81.9399 150.908 81.986 151.141 81.9862H189.316C189.549 81.986 189.779 81.9399 189.994 81.8507C190.209 81.7614 190.405 81.6306 190.569 81.4658C190.734 81.3011 190.864 81.1056 190.952 80.8905C191.041 80.6755 191.086 80.4451 191.085 80.2126V76.5136C191.085 76.0108 190.885 75.5286 190.528 75.173C190.172 74.8174 189.689 74.6175 189.185 74.6172Z",
    fill: "#2B2B33"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M157.632 2H174.629",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M157.632 6.89062H174.629",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M157.632 11.7773H174.629",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M285.003 89.8203H302",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M285.003 94.7109H302",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M285.003 99.6016H302",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9623 56.4141H33.9596",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9623 61.3008H33.9596",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9623 66.1914H33.9596",
    stroke: "#DEDEDE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.39f74e5aee1ccb9088ad19dc21153a96.svg";
export { ForwardRef as ReactComponent };